import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { DepartmentResponse } from '../../responses/admin-user/department.response';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }
    
  public listDepartment(): Observable<DepartmentResponse> {
      
    return this.httpClient.get<DepartmentResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + "Department", this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
    
    